define([
    'text!WebCommon/modal/member-login.html',
    'WebCommon/mixin/modal',
    'WebCommon/auth',
    'WebCommon/api',

    'wxLogin',
    'css!WebCommon/modal/member-login.css'
], function(
    tpl,
    ModalMixin,
    Auth,
    Api
){
    function genDefaultInfo(){
        return {
            phone: '',
            password: '',
            rememberMe: false
        };
    }
    function genDefaultQuickInfo(){
        return {
            phone: '',
            verifyCode: ''
        };
    }
    return {
        template: tpl,
        mixins: [ModalMixin],
        data: function(){
            return {
                info: genDefaultInfo(),
                infoQuick: genDefaultQuickInfo(),
                qrcodeId: 'wx_qrcode',
                isQuickLogin:true
            };
        },
        computed: {
            backUrl: function(){
                return this.modalData.from || window.location.href;
            }
        },
        watch: {
            value: function(v){
                if (v) {
                    this.initWxLogin();
                }
            }
        },
        methods: {
            changeQuickLogin:function()
            {
                this.isQuickLogin = !this.isQuickLogin;
            },
            sendVerifyCode: function(){
                var phone = this.infoQuick.phone;
                if (!phone){
                    return alert('手机或邮箱格式错误');
                }
                Api.sendVerifyCodeApi.ajax({phone:phone, jammer:FNJISite.user.jammer})
                    .done(function(data){
                        alert(data);
                    });
            },
            loginQuick:function(){
                this.infoQuick['isQuickLogin'] = true;
                Auth.login(this.infoQuick, this.modalData.from);
            },
            login: function(){
                this.info['isQuickLogin'] = false;
                Auth.login(this.info, this.modalData.from);
            },
            initWxLogin: function(){
                var _this = this;
                Api.getWxLoginInfoApi.ajax({backUrl: this.backUrl})
                    .done(function(data){
                        new WxLogin({
                            id:_this.qrcodeId,
                            appid: "wx9d5a22c9e6d334c2",
                            scope: "snsapi_login",
                            redirect_uri: data.callback,
                            href: 'data:text/css;base64,KiB7DQogICAgbWFyZ2luOiAwOw0KICAgIHBhZGRpbmc6IDA7DQp9DQouaW1wb3dlckJveCB7DQogICAgbGluZS1oZWlnaHQ6IDE7DQogICAgZm9udC1zaXplOiAwOw0KfQ0KLmltcG93ZXJCb3ggLnRpdGxlLA0KLmltcG93ZXJCb3ggLmluZm8NCnsNCiAgICBkaXNwbGF5OiBub25lOw0KfQ0KLmltcG93ZXJCb3ggLnFyY29kZSB7DQogICAgYm9yZGVyOiBub25lOw0KICAgIG1hcmdpbi10b3A6IDA7DQogICAgd2lkdGg6IDE1MHB4Ow0KfQ=='
                        });
                    });
            },
            register: function(){
                this.hide();
                this.$emit('register');
            },
            resetPass: function(){
                this.hide();
                this.$emit('reset-pass');
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/modal/member-login.js
// module id = 35
// module chunks = 0 1 2 3 4 5 6